import React from 'react'

function SocialScience() {
  return (
    <div>SocialScience</div>
  )
}

export default SocialScience